import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  "class": "flex flex-wrap -mb-1"
};
var _hoisted_3 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Link = _resolveComponent("Link");
  return $props.links.length > 3 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.links, function (link, key) {
    return _openBlock(), _createElementBlock(_Fragment, null, [link.url === null ? (_openBlock(), _createElementBlock("div", {
      key: key,
      "class": "mb-1 mr-1 px-4 py-3 text-gray-400 text-sm leading-4 border rounded",
      innerHTML: link.label
    }, null, 8, _hoisted_3)) : (_openBlock(), _createBlock(_component_Link, {
      key: "link-".concat(key),
      "class": _normalizeClass(["mb-1 mr-1 px-4 py-3 focus:text-indigo-500 text-sm leading-4 hover:bg-white border focus:border-indigo-500 rounded", {
        'bg-white': link.active
      }]),
      href: link.url,
      innerHTML: link.label
    }, null, 8, ["class", "href", "innerHTML"]))], 64);
  }), 256))])])) : _createCommentVNode("", true);
}